import React from 'react';
import { map, isEmpty } from 'lodash';
import classnames from 'classnames';

import { getLabel } from 'utils/getLabel';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { cSrOrderListNotesLineItemPreloader as CSrOrderListNotesLineItemPreloader } from 'ui/views/widgets/cSROrderListNotesLineItem';
import { widgetError as WidgetError } from 'ui/views/widgets/widgetError';
import { WIDGET_ERROR_TYPE } from 'constants/common';
import { button as Button } from 'modules/button';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { cSrOrderListNotesWorkFlowItem as CSrOrderListNotesWorkFlowItem } from 'ui/views/widgets/cSROrderListNotesWorkFlowItem';
 *
 * // render
 * <cSrOrderListNotesWorkFlowItem propName='propValue'/>
 */
export const cSrOrderListNotesWorkFlowItemSuccess = ( props ) => {

    // if( isEmpty( props.items ) ) {
	// 	return <WidgetError type={ WIDGET_ERROR_TYPE.NO_DATA_FOUND} />;
    // }
    
    return (
            <div className='ui-c-sr-order-list-notes-work-flow-item'>
                <div className='ui-c-sr-order-list-notes-work-flow-item__list'>

                    { isEmpty( props.items ) ? (
                        <WidgetError type={ WIDGET_ERROR_TYPE.NO_DATA_FOUND} />
                    ) : (
                        <>
                            { map( props.items, ( item, itemIndex ) => (
                                <div key={ item.id + itemIndex } className='ui-c-sr-order-list-notes-work-flow-item__list__table'>
                                    <div className='ui-c-sr-order-list-notes-work-flow-item__list__table__title'>
                                        { getLabel( props.displayDateText ) } : { item.noteDate }
                                    </div>
                                    <div className='ui-c-sr-order-list-notes-work-flow-item__list__table__description'>
                                        { item.comment }
                                    </div>
                                </div>
                            ) )}
                        </>
                    ) }
                    
                </div>

                <div className='ui-c-sr-order-list-notes-work-flow-item__actions'>
                    { map( props.actions, action => {
                        return (
                            <Button
                                key={ action.name }
                                { ...action }
                                outline={ 'cancel' !== action.name ? true: false }
                                size='large'
                                className='ui-c-sr-order-list-notes-work-flow-item__actions__action'
                                onClick={'cancel' !== action.name ? () => props.onAddClick( true ) : () => props.onCancelClick() }
                            />
                        );
                    } ) }
                </div>
                
            </div>
    );
};

// set display name
cSrOrderListNotesWorkFlowItemSuccess.displayName = 'cSrOrderListNotesWorkFlowItemSuccess';

// set default props
cSrOrderListNotesWorkFlowItemSuccess.defaultProps = {};

/*******************************/

// preloader view
export const cSrOrderListNotesWorkFlowItemPreloader = ( props ) => {

    // widget class name
    const widgetClassName = classnames( 'ui-c-sr-order-notes-preloader', props.className );

    return (
        <div className={widgetClassName}>
             <CSrOrderListNotesLineItemPreloader />
        </div>
    );
};

// set display name
cSrOrderListNotesWorkFlowItemPreloader.displayName = 'cSrOrderListNotesWorkFlowItemPreloader';

// set default props
cSrOrderListNotesWorkFlowItemPreloader.defaultProps = {};

// prop types
cSrOrderListNotesWorkFlowItemPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { cSrOrderListNotesWorkFlowItem as cSrOrderListNotesWorkFlowItem } from 'ui/views/widgets/cSrOrderListNotesWorkFlowItem';
 *
 * // render
 * <cSrOrderListNotesWorkFlowItem propName='propValue'/>
 */
export const cSrOrderListNotesWorkFlowItem = withNetworkState( cSrOrderListNotesWorkFlowItemPreloader, cSrOrderListNotesWorkFlowItemSuccess );
